import { render, staticRenderFns } from "./PurchaseQuotation.vue?vue&type=template&id=2ab053fe&scoped=true"
import script from "./PurchaseQuotation.vue?vue&type=script&lang=js"
export * from "./PurchaseQuotation.vue?vue&type=script&lang=js"
import style0 from "./PurchaseQuotation.vue?vue&type=style&index=0&id=2ab053fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab053fe",
  null
  
)

export default component.exports